import { Component, inject } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideCheck } from '@ng-icons/lucide';
import { SidepanelService } from '@shared/components/sidepanel/sidepanel.service';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';

@Component({
  selector: 'app-import-module-footer',
  imports: [HlmButtonImports, HlmIconImports],
  providers: [provideIcons({ lucideCheck })],
  template: `<div class="flex justify-between">
    <button
      class="text-components-content-neutral-secondary component-medium-medium"
      (click)="cancel()"
      hlmBtn
      variant="link"
      type="button"
    >
      Fermer le panneau
    </button>
    <button [disabled]="sidepanelService.loading()" (click)="submit()" hlmBtn type="submit" variant="secondary">
      <ng-icon name="lucideCheck" />
      Importer le module
    </button>
  </div>`,
})
export class ImportModuleFooterComponent {
  readonly sidepanelService = inject(SidepanelService);

  cancel() {
    this.sidepanelService.resetComponentToDisplay();
    this.sidepanelService.close();
  }

  submit() {
    this.sidepanelService.onSubmit();
  }
}
